import { Directive, ElementRef, OnInit } from '@angular/core';
import IMask from 'imask';
@Directive({
  selector: '[dateInput]'
})
export class DateDirective implements OnInit {
  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    var maskOptions = {
      mask: 'd-m-j',
      lazy: false,
      autofix: true,
      blocks: {
        d: { mask: '00', placeholderChar: 'd' },
        m: { mask: '00', placeholderChar: 'm' },
        j: { mask: '0000', placeholderChar: 'j' }
      }
    };
    this.element.nativeElement.mask = IMask(this.element.nativeElement, maskOptions);
  }
}